import React from 'react';
import { FadeIn } from './FadeIn';
export function ComparisonTable() {
  const comparisons = [{
    tried: 'Cremas mentoladas de farmacia',
    failed: 'Solo refrescan la piel, no llegan a la inflamación'
  }, {
    tried: "Pastillas 'PM' para dormir",
    failed: 'La dejan mareada y con neblina al día siguiente'
  }, {
    tried: "Tés de bolsa 'naturales' del súper",
    failed: 'Llenos de azúcar y sin principio activo real'
  }, {
    tried: 'Antiácidos masticables',
    failed: 'Disfrazan el problema digestivo, no lo sanan'
  }, {
    tried: 'Remedios de su país',
    failed: 'Ya no los consigue aquí o perdieron su fuerza'
  }];
  return <section className="py-20 px-6 max-w-4xl mx-auto" data-id="element-20">
      <FadeIn data-id="element-21">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-brown-dark mb-12" data-id="element-22">
          ¿Por Qué Todo lo que Ha Intentado No Ha Funcionado?
        </h2>

        <div className="hidden md:block overflow-hidden rounded-2xl shadow-lg border border-cream-dark bg-white mb-10" data-id="element-23">
          <table className="w-full text-left border-collapse" data-id="element-24">
            <thead data-id="element-25">
              <tr className="bg-sage text-white" data-id="element-26">
                <th className="p-6 text-xl font-serif font-medium w-1/2" data-id="element-27">
                  Lo que intentó
                </th>
                <th className="p-6 text-xl font-serif font-medium w-1/2" data-id="element-28">
                  Por qué falló
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-cream-dark" data-id="element-29">
              {comparisons.map((item, index) => <tr key={index} className="hover:bg-cream/50 transition-colors" data-id="element-30">
                  <td className="p-6 text-lg font-medium text-brown-dark" data-id="element-31">
                    {item.tried}
                  </td>
                  <td className="p-6 text-lg text-brown" data-id="element-32">{item.failed}</td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Mobile view */}
        <div className="md:hidden space-y-6 mb-10" data-id="element-33">
          {comparisons.map((item, index) => <div key={index} className="bg-white rounded-2xl p-6 shadow-md border border-cream-dark" data-id="element-34">
              <div className="mb-3" data-id="element-35">
                <span className="text-sm font-bold uppercase tracking-wider text-sage-dark" data-id="element-36">
                  Lo que intentó:
                </span>
                <p className="text-lg font-medium text-brown-dark mt-1" data-id="element-37">
                  {item.tried}
                </p>
              </div>
              <div className="pt-3 border-t border-cream-dark" data-id="element-38">
                <span className="text-sm font-bold uppercase tracking-wider text-terracotta" data-id="element-39">
                  Por qué falló:
                </span>
                <p className="text-lg text-brown mt-1" data-id="element-40">{item.failed}</p>
              </div>
            </div>)}
        </div>

        <div className="text-center bg-amber/10 p-6 rounded-2xl border border-amber/20" data-id="element-41">
          <p className="text-xl font-medium text-brown-dark" data-id="element-42">
            La verdad es que nadie le ha enseñado a usar lo que ya existe en los
            pasillos de su propio supermercado.
          </p>
        </div>
      </FadeIn>
    </section>;
}